import React, { Component, useEffect, useState } from 'react';
import ClassNames from 'classnames';
import { Child } from 'pym.js';
import App from './App.css';

import { questions, description } from '../data/questions.json';

export default class extends Component {
  // State
  // -------

  state = {
    currentQuestion: 0,
    score: 0,
    correct: '',
    results: [],
    isComplete: false,
  };

  // Constructor
  // -------------

  constructor(props) {
    super(props);
  }

  // Events
  // --------

  onNextButtonClick = (e) => {
    const icons = document.getElementsByClassName('icons');

    pymChild.sendHeight();

    icons.forEach((icon) => {
      icon.style.display = 'none';
    });
    // Check if currentQuestion question has been answered.
    if (this.state.results.length <= this.state.currentQuestion) return;

    questions.length == this.state.results.length
      ? this.setState({ isComplete: true })
      : this.setState({ currentQuestion: this.state.currentQuestion + 1 });

    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  };

  onAnswerClicked = (e) => {
    const icons = document.getElementsByClassName('icons');

    icons.forEach((icon) => {
      icon.style.display = 'block';
    });

    if (this.state.results.length > this.state.currentQuestion) return;

    const answerIdx = parseInt(e.currentTarget.dataset.id);
    const isCorrect = questions[this.state.currentQuestion].answerOptions[answerIdx]
      .isCorrect == 'true';

    this.setState({
      results: [...this.state.results, { answer: answerIdx, isCorrect }],
    });

    if (e.target.getAttribute('data-choice') === 'true') {
      this.setState({ score: this.state.score + 1 });
      this.setState({ correct: 'Correct!' });
    } else {
      this.setState({ correct: 'Incorrect.' });
    }
  };

  onReset = (e) => {
    this.setState({
      currentQuestion: 0,
      results: [],
      score: 0,
      isComplete: false,
    });
  };

  // Build
  // -------

  getResutsScreen = () => (
    <div id="resultsDiv">
      <h1>
        You answered {this.state.score} out of {questions.length} correctly.
      </h1>
      <h2 className="quizPrompt">
        {this.state.score < 6
          ? this.state.score === 8
            ? 'Perfect!'
            : 'Give it another try!'
          : 'Good job!'}
      </h2>

      <button className="restartButton " onClick={this.onReset}>
        <p>Take it again </p>
        <img src="img/white-arrow-icon.png" />
      </button>
      <p className="footer" style={{ 'text-align': 'center' }}>
        Quiz by Alexandra Meeks, CNN{' '}
      </p>
    </div>
  );

  getQuiz = () => (
    <div id="contentBox" className={ClassNames({ answered: this.isAnswered })}>
      <div className="questionCount">
        {' '}
        <h3>
          {this.state.currentQuestion + 1} of {questions.length}
        </h3>
      </div>

      <div
        className="questionDiv"
        dangerouslySetInnerHTML={{
          __html: `<p>${questions[this.state.currentQuestion].questionText}</p>`,
        }}
      />

      <div id="imageDiv">
        <img
          src={questions[this.state.currentQuestion].imgPath}
          className={
            questions[this.state.currentQuestion].photoQuestion
            && !this.isAnswered
              ? 'blur'
              : ''
          }
        />
      </div>

      <p className="photoCredit">
        {questions[this.state.currentQuestion].caption}
      </p>

      <div className="buttonDiv">
        {questions[this.state.currentQuestion].answerOptions.map(
          (answer, a_id) => (
            <button
              className={`btn-id-${a_id}`}
              className={ClassNames('answerOptions', {
                correct: this.isAnswered && answer.isCorrect == 'true',
              })}
              onClick={this.onAnswerClicked}
              data-id={a_id}
              data-choice={answer.isCorrect === 'true'}
            >
              {answer.answerText}
              <img className="icons" src={answer.answerIcon} />
            </button>
          ),
        )}
      </div>

      {this.isAnswered && (
        <div id="correctAnswerDiv">
          <p>
            {' '}
            <span style={{ fontWeight: '800' }}>
              {this.state.correct}{' '}
            </span>{' '}
            <p
              dangerouslySetInnerHTML={{
                className: 'answerCopy',
                __html: `<p>${
                  questions[this.state.currentQuestion].correctAnswer
                }</p>`,
              }}
            />{' '}
            {/* <a
              style={{ color: 'blue', 'text-decoration': 'underline' }}
              href={questions[this.state.currentQuestion].storyLink}
              className={
                questions[this.state.currentQuestion].storyLink ? '' : 'hidden'
              }
            >
              Story here
            </a> */}
          </p>
        </div>
      )}

      <div id="nextDiv">
        <button className="nextButton" onClick={this.onNextButtonClick}>
          <p className="nextQuestionText">
            {this.state.currentQuestion !== 9 ? 'Next Question' : 'The end'}
          </p>
          <img className="nextButtonImg" src="img/black-arrow-icon.png" />
        </button>
      </div>
    </div>
  );

  componentDidUpdate() {
    pymChild.sendHeight();
  }
  // Render
  // --------

  render = () => questions && (
      <div id="quizBox">
        <div className="lineOne" />
        <h2>
          {description}
        </h2>
        {this.state.isComplete == true
          ? this.getResutsScreen()
          : this.getQuiz()}

        <div className="lineTwo" />
      </div>
  );

  // Getters / Setters
  // -------------------

  get isAnswered() {
    return this.state.results.length > this.state.currentQuestion;
  }
}

window.pymChild = new Child();
